// src/components/hr/GetCertified.js
import { useEffect, useRef, useState, useContext } from "react";
import axios from "axios";
import Utils from "../Utils";
import UserContext from "../contexts/UserContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../scormApi"; // IMPORTANT: just import once to register API
const MySwal = withReactContent(Swal);

const GetCertified = () => {
  const { initUserData, userData } = useContext(UserContext);
  const iframeRef = useRef(null);
  const completedOnceRef = useRef(false);
  const [started, setStarted] = useState(false);
  const SCORM_URL = `${process.env.PUBLIC_URL}/scormfiles/${userData?.isHR ? "scorm" : "scorm"}/index_lms.html`;
  const COURSE_ID = userData?.isHR ? 1 : 2; // example: 1 for HR, 2 for PG

  /* -------- Restore Resume BEFORE launch -------- */
  // useEffect(() => {
  //   axios
  //     .get(Utils.apiUrl(`scorm/progress/${COURSE_ID}`))
  //     .then((res) => {
  //       const data = res.data;
  //       if (!data) return;
  //       // ...existing code...
  //     })
  //     .catch(() => {});
  //   // For now, just log a placeholder
  //   console.log("SCORM_RESUME", JSON.stringify({ courseId: COURSE_ID, version: "SCORM_2004", location: "", suspendData: "" }, null, 2));
  // }, []);

  /* -------- Listen to SCORM events -------- */

  useEffect(() => {
    const onProgress = (e) => {
      // axios.post(Utils.apiUrl("scorm/progress"), {
      //   courseId: COURSE_ID,
      //   ...e.detail,
      // });
      console.log("SCORM_PROGRESS", JSON.stringify({ courseId: COURSE_ID, ...e.detail }, null, 2));
    };

    const onCompleted = async (e) => {
      const detail = e.detail;
      console.log("SCORM_COMPLETED", JSON.stringify({ courseId: COURSE_ID, ...detail }, null, 2));
      // Guard: prevent duplicate API calls
      if (completedOnceRef.current) return;

      // Condition check
      if (detail.completed === true && detail.status === "passed") {
        completedOnceRef.current = true;

        certifyUser();
      }
    };

    //console.log("SCORM_COMPLETED", JSON.stringify({ courseId: COURSE_ID, ...e.detail }, null, 2));
    window.addEventListener("SCORM_PROGRESS", onProgress);
    window.addEventListener("SCORM_COMPLETED", onCompleted);

    return () => {
      window.removeEventListener("SCORM_PROGRESS", onProgress);
      window.removeEventListener("SCORM_COMPLETED", onCompleted);
    };
  }, []);

  const certifyUser = () => {
    const formData = new FormData();
    formData.append("course_id", 1); // backend expects numeric ID

    axios
      .post(Utils.apiUrl("frontend/auth/certify"), formData, Utils.apiHeaders())
      .then((res) => {
        if (res.data?.success) {
          initUserData(res.data);
          MySwal.fire({
            title: "Congratulations!",
            text: "Certification recorded successfully.",
            icon: "success",
            buttonsStyling: false,
            customClass: {
              popup: "rounded-xl",
              confirmButton: "bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded",
            },
          }).then(() => {
            window.location.href = userData?.isHR ? "/hotel-representative-dashboard" : "/photographer-dashboard";
          });
        }
      })
      .catch(() => {
        MySwal.fire({
          title: "Error",
          text: "Failed to record certification.",
          icon: "error",
          buttonsStyling: false,
          customClass: {
            popup: "rounded-xl",
            confirmButton: "bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded",
          },
        });
      });
  };

  window["certifyUser"] = certifyUser; // for testing

  return (
    <main className="container mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-6">Get Certified</h1>
      {/* replce onclick actual course progress => onClick={() => setStarted(true)} */}
      {!started && (
        <div
          className="play-box w-full cursor-pointer border rounded p-12 text-center"
          onClick={() => {
            window.certifyUser();
            setStarted(true);
          }}
        >
          <i className="fas fa-play text-4xl mb-4"></i>
          <div className="text-lg font-semibold">Click to start the certification</div>
        </div>
      )}

      {started && (
        <iframe ref={iframeRef} src={SCORM_URL} title="SCORM Player" style={{ width: "100vw", height: "100vh", border: "none" }} allow="fullscreen" />
      )}
    </main>
  );
};

export default GetCertified;
